import React, { useState } from 'react';
import { Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

/**
 * DateRangePicker Component
 * Allows selecting a date range (from - to)
 * 
 * @param {object} value - Object with 'from' and 'to' date values
 * @param {function} onChange - Callback when date range changes
 */
const DateRangePicker = ({ value, onChange }) => {
  const [fromDate, setFromDate] = useState(value?.from ? dayjs(value.from) : null);
  const [toDate, setToDate] = useState(value?.to ? dayjs(value.to) : null);

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
    onChange({ 
      from: newDate ? newDate.toDate() : null, 
      to: toDate ? toDate.toDate() : null 
    });
  };

  const handleToDateChange = (newDate) => {
    setToDate(newDate);
    onChange({ 
      from: fromDate ? fromDate.toDate() : null, 
      to: newDate ? newDate.toDate() : null 
    });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: 'flex', gap: { xs: 1, sm: 2 }, flexWrap: { xs: 'wrap', sm: 'nowrap' }, width: '100%' }}>
        <DatePicker
          label="From Date"
          value={fromDate}
          onChange={handleFromDateChange}
          slotProps={{ 
            textField: { 
              size: 'small',
              fullWidth: true,
              sx: { 
                minWidth: { xs: '100%', sm: 'auto' },
                flex: { xs: '1 1 100%', sm: '0 1 auto' }
              }
            } 
          }}
        />
        <DatePicker
          label="To Date"
          value={toDate}
          onChange={handleToDateChange}
          minDate={fromDate}
          slotProps={{ 
            textField: { 
              size: 'small',
              fullWidth: true,
              sx: { 
                minWidth: { xs: '100%', sm: 'auto' },
                flex: { xs: '1 1 100%', sm: '0 1 auto' }
              }
            } 
          }}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default DateRangePicker;

